import React from "react";

import { Input } from "@ts-digital/vrc";

const TextInput = ({ input, meta, ...props }) => (
    <Input {...input} {...props} error={meta.touched === true && meta.error !== undefined} errorMessage={meta.error} />
);

export default TextInput;
